// 引入axios封装
import axios from 'axios';
import { ElMessage, ElMessageBox } from 'element-plus';
// 创建axios实例
const request = axios.create({
  baseURL: '', // url = base url + request url
  timeout: 10000 // 5s超时
});

// 请求拦截器 一般写法模式
request.interceptors.request.use(
  config => {
    // console.log('---request config--')
    // 默认使用nProgress的进度条
    // if (store.getters.loading === 0 || store.getters.loading === 1) {
    //   store.commit('setLoading', 1)
    //   NProgress.start()
    // }
    return config;
  },
  error => {
    // 请求失败则显示错误状态
    ElMessage.error(error.message);
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  response => {
    const { data } = response;
    if (data && data.errcode !== 0) {
      // TODO
    }
    return data;
  },
  error => {
    ElMessage.error(error.message);
    return Promise.reject(error);
  }
);

// 导出request
export default request;
